import { motion } from 'framer-motion';

import { Separator } from '@/modules/ui/components/separator/Separator';
import { Skeleton } from '@/modules/ui/components/skeleton/Skeleton';

interface CandidateCardSkeletonProps {
  showCandidateBackground?: boolean;
}

export function CandidateCardSkeleton({
  showCandidateBackground = false,
}: CandidateCardSkeletonProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <div className="bg-card rounded-xl border">
        <div className="flex items-center gap-4 px-6 py-4">
          <Skeleton className="h-4 w-4 shrink-0" />

          <div className="flex min-w-0 flex-col gap-1">
            <div className="flex items-center gap-2">
              <Skeleton className="h-5 w-40" />
              <Skeleton className="h-5 w-16 rounded-full" />
            </div>
            <Skeleton className="h-4 w-64" />
          </div>

          <div className="ml-auto flex shrink-0 items-center gap-4">
            <Skeleton className="h-8 w-8 rounded-full" />
            <Skeleton className="h-8 w-24 rounded-md" />
          </div>
        </div>

        {showCandidateBackground && (
          <>
            <Separator />
            <div className="px-6 py-5">
              <div className="flex flex-wrap gap-8">
                {/* Work experience timeline */}
                <div className="flex-1 space-y-4">
                  <Skeleton className="h-4 w-48" />
                  <Skeleton className="h-4 w-40" />
                  <Skeleton className="h-4 w-44" />
                </div>

                <div className="bg-border -my-5 hidden w-px self-stretch md:block" />

                <div className="flex-1">
                  <div className="flex flex-wrap gap-2">
                    <Skeleton className="h-4 w-24 rounded-full" />
                    <Skeleton className="h-4 w-24 rounded-full" />
                    <Skeleton className="h-4 w-28 rounded-full" />
                    <Skeleton className="h-4 w-24 rounded-full" />
                    <Skeleton className="h-4 w-24 rounded-full" />
                    <Skeleton className="h-4 w-24 rounded-full" />
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </motion.div>
  );
}
